module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAsCAYAAABPEGliAAAAF0lEQVQoU2P8E1v/n4GBgYFxlDHQgQAAxPd9IQBe5QYAAAAASUVORK5CYII="